export class RegisterSapAgentInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "agentVersion",
            "baseName": "agentVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "contractVersion",
            "baseName": "contractVersion",
            "type": "number",
            "format": ""
        },
        {
            "name": "deploymentShape",
            "baseName": "deploymentShape",
            "type": "SapDeploymentShape",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RegisterSapAgentInput.attributeTypeMap;
    }
    constructor() {
    }
}
